import { render, staticRenderFns } from "./EditRoleComponent.vue?vue&type=template&id=1fbaacec"
import script from "./EditRoleComponent.vue?vue&type=script&lang=js"
export * from "./EditRoleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports